import React, { useState } from "react";

import MakeAPICall from "../../apiCalls/common";
import { changePasswordApiRoute } from "../../apiRoutes";

import Loader from "../../components/loader";
import ChangePasswordForm from "../../containers/ChangePasswordForm";

const ChangePasswordPage = props => {
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);

  const onFormSubmit = async formValues => {
    setIsProcessing(true);

    await setApiCallParams({
      reqType: "PUT",
      reqUrl: changePasswordApiRoute,
      dataObj: {
        oldPassword: formValues.oldPassword,
        newPassword: formValues.newPassword
      },
      successCallback: res => {
        setSuccessMsg(res.data.message);
        setErrorMsg("");
        setIsProcessing(false);
      },
      failureCallback: err => {
        // setErrorMsg(err.message);
        // setSuccessMsg("");
        setIsProcessing(false);
      }
    });

    setTimeout(() => {
      resetStates();
    }, 4000);
  };

  const resetStates = () => {
    setSuccessMsg("");
    setErrorMsg("");
    setIsProcessing(false);
  };

  return (
    <div className="view-ticket-container">
      <div className="d-flex flex-row flex-wrap justify-content-between">
        {isProcessing && <Loader />}
        <div className={isProcessing ? "disableContainer w-100" : "w-100"}>
          <ChangePasswordForm
            onFormSubmit={onFormSubmit}
            serverErrorMsg={errorMsg}
            successMsg={successMsg}
          />
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
      </div>
    </div>
  );
};

export default ChangePasswordPage;
